<template>
  <div id="main">
    <div class="video-container">
      <video class="video" ref="myVideo" @click="playVideo"
             src="//download.wrightin.com/website/product-t20.mp4"
             muted autoplay loop
             :poster="require('@/assets/img/product/t20/video_cover.png')" @contextmenu.prevent
             playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true"
             @pause="playState(false)" @play="playState(true)">
      </video>
      <img v-if="!isVideoPlaying" class="playBtn" @click.stop="playVideo"
           :src='require("@/assets/img/product/t20/play_circle.png")' />
      <div class="copyright"></div>
    </div>
    <div class="product-show">
      <div class="title">
        <img v-lazy="require('@/assets/img/product/t20/main-top.png')" class="top">
        <p class="title">双重治疗修复<br/>双效提升健康状态</p>
        <p class="sub-title">盆底康复+私密抗衰</p>
      </div>
      <img v-lazy="require('@/assets/img/product/t20/main-bottom.png')">
      <div class="bottom-gradient"></div>
      <div class="img-copyright">广告审查批准文号:苏械广审(文)第270509-08266号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准 20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="banner">
      <div id="bannerSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(bannerItem, bannerIndex) in bannerList" :key="bannerIndex">
            <div class="img-container">
              <img :src="bannerItem.path" alt="" />
              <div style="right: 2rem;line-height: 0.8rem;bottom: 0.6rem;" class="img-copyright" v-html="bannerItem.words"></div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="img-copyright">广告审查批准文号:苏械广审(文)第270509-08212号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准 20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司</div>
    </div>
    <div class="pattern">
      <div class="video-container-pattern">
        <video src="//download.wrightin.com/website/product-t20-4.mp4"
               class="video" ref="myVideoPattern" @click="playVideoPattern"
               poster="//download.wrightin.com/website/product-t20-4.mp4?x-oss-process=video/snapshot,t_0,f_jpg,m_fast"
               muted autoplay loop @contextmenu.prevent
               playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true"
               x5-playsinline="true" @pause="playStatePattern(false)" @play="playStatePattern(true)"></video>
        <img v-if="!isVideoPlayingPattern" class="playBtn" @click.stop="playVideoPattern"
             :src='require("@/assets/img/product/t20/play_circle.png")' />
        <div class="img-copyright" style="right: 2.2rem;bottom: 4.2rem;line-height: 0.8rem;"></div>
      </div>
    </div>
    <div class="technology">
      <div class="top">
        <img alt :src="require('@/assets/img/product/t20/technology-top.png')"/>
        <p>神经肌肉电刺激</p>
        <p>采用双向对称方波技术，通过电刺激引起盆底肌肉被动收缩，改善盆底血液循环。</p>
      </div>
      <div class="bottom">
        <!--            <video src="//download.wrightin.com/website/product-e10-2.mp4" autoplay muted loop-->
        <!--                   @contextmenu.prevent-->
        <!--                   playsinline="true" preload="auto" x5-video-player-type="h5" webkit-playsinline="true"-->
        <!--                   x5-playsinline="true"-->
        <!--            ></video>-->
        <img alt :src="require('@/assets/img/product/t20/technology-bottom.png')"/>
        <p>肌电生物反馈</p>
        <p>通过阴道电极采集盆底肌表面的肌电信号转化为可视化图像，当收缩肌力达到预设的阈值，智能触发电刺激，增强肌肉的反应和锻炼效果。</p>
      </div>
      <div class="img-copyright">
        广告审查批准文号:苏械广审(文)第270509-08266号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准 20242090347<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司
      </div>
    </div>

    <div class="product-standard">
      <div class="desc">
        <p>6大作用机理</p>
      </div>
      <div id="standardSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(standardItem, standardIndex) in mechanismList" :key="standardIndex">
            <div class="img-container">
              <img :src="standardItem.path" alt="" />
            </div>
            <div class="title" v-html="standardItem.title"></div>
            <div class="words" v-html="standardItem.words"></div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="img-copyright">
        广告审查批准文号:苏械广审(文)第270509-08973号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准 20242090347<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司
      </div>
    </div>

    <div class="four-advantages">
      <div
          class="feature-card"
          v-for="(item, index) in advantagesList"
          :key="index"
      >
        <!-- 图片容器 -->
        <div class="card-img">
          <img :src="item.path" alt/>
        </div>
        <!-- 文字容器（带滑动动画） -->
        <div class="text-wrap" :class="{ slide: hoverIndex === index }">
          <p class="main-text">{{ item.title }}</p>
          <p class="sub-text">{{ item.desc }}</p>
        </div>
        <div class="img-copyright" v-html="item.word"></div>
      </div>
    </div>

    <div class="feature">
      <video class="video"
             src="//download.wrightin.com/website/product-t20-5.mp4"
             poster="//download.wrightin.com/website/product-t20-5.mp4?x-oss-process=video/snapshot,t_0,f_jpg,m_fast"
             muted autoplay loop
             @contextmenu.prevent
             playsinline preload="auto" x5-video-player-type="h5" webkit-playsinline="true" x5-playsinline="true">
      </video>
      <div class="video-cover"></div>
      <p class="title">4大技术加持</p>
      <p class="desc">科学守护女性盆底健康</p>
      <div id="designSwiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(designItem, designIndex) in designList" :key="designIndex">
            <div class="img-container">
              <img :src="designItem.path" alt="" />
            </div>
            <div class="Introduction">
              <p class="title">{{ designItem.title }}</p>
              <p class="desc">{{ designItem.desc }}</p>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <div class="img-copyright" style="color: #ccc; bottom: 0.2rem;">
        广告审查批准文号:苏械广审(文)第270509-08264号<br/>盆底康复治疗仪 医疗器械注册号:苏械注准 20242090347<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用  禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司
      </div>
    </div>
    <div class="research">
      <img v-lazy="require('@/assets/img/product/t20/zheng.png')" class="bg" />
      <p class="title">国际权威验证 专研盆底紧致</p>
      <p class="sub-title">《电刺激生物反馈在产后盆底功能康复中的临床效果评价》</p>
      <img v-lazy="require('@/assets/img/product/t20/research.png')" class="img">
      <div class="img-copyright" style="bottom: 4.6rem;"></div>
    </div>
    <div class="zhuanli">
      <p class="title">医疗器械认证及专利</p>
      <p class="sub-title"></p>
      <div class="list">
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-1.png')" class="img" />
          <p class="title">盆底康复治疗仪</p>
          <p class="desc">二类医疗器械</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-2.png')" class="img" />
          <p class="title">发明专利</p>
          <p class="desc">ZL 2023 1 1543573.4</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-3.png')" class="img" />
          <p class="title">发明专利</p>
          <p class="desc">ZL 2023 1 0913296.5</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-4.png')" class="img" />
          <p class="title">发明专利</p>
          <p class="desc">ZL 2023 1 1802368.5</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-5.png')" class="img" />
          <p class="title">外观设计专利</p>
          <p class="desc">ZL202330448897.4</p>
        </div>
        <div class="item">
          <img v-lazy="require('@/assets/img/product/t20/zhuanli-6.png')" class="img" />
          <p class="title">外观设计专利</p>
          <p class="desc">ZL 2023 3 0481048.9</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  data() {
    return {
      showCopyright: true,
      showCopyrightTimer: null,
      rem: document.documentElement.style.fontSize.replace("px", "") * 1,
      isVideoPlaying: false,
      isVideoPlayingPattern: false,
      bannerSwiper: null,
      standardSwiper: null,
      bannerList: [
        {
          path: require("@/assets/img/product/t20/system-1.png"),
          title: "",
          desc: "",
          words: ""
        },
        {
          path: require("@/assets/img/product/t20/system-2.png"),
          title: "",
          desc: "",
          words: ""
        }
      ],
      designSwiper: null,
      designList: [
        {
          path: require("@/assets/img/product/t20/design-1.png"),
          title: "无线一体化设计",
          desc: "一键开启 摆脱有线束缚"
        },
        {
          path: require("@/assets/img/product/t20/design-2.png"),
          title: "UVC紫外线消毒",
          desc: "7颗UVC灯珠 紫外线消毒"
        },
        {
          path: require("@/assets/img/product/t20/design-3.png"),
          title: "探头加热振感",
          desc: "加热功能 温和促进局部血液循环 温柔震感提示"
        },
        {
          path: require("@/assets/img/product/t20/design-4.png"),
          title: "充电收纳二合一",
          desc: "专属充电收纳仓 保护机身 长效护航"
        }
      ],
      mechanismList: [
        {
          path: require('@/assets/img/product/t20/mechanism-1.png'),
          title: '智能生物反馈<br/>自主掌控盆底状态',
        },
        {
          path: require('@/assets/img/product/t20/mechanism-2.png'),
          title: '修复盆底损伤肌肉<br/>提升两性生活质量',
        },
        {
          path: require('@/assets/img/product/t20/mechanism-3.png'),
          title: '科学脉冲技术<br/>兴奋神经肌肉组织',
        },
        {
          path: require('@/assets/img/product/t20/mechanism-4.png'),
          title: '低频脉冲电流<br/>引起肌肉收缩锻炼肌肉',
        },
        {
          path: require('@/assets/img/product/t20/mechanism-5.png'),
          title: '促进局部血液循环<br/>和消肿',
        },
        {
          path: require('@/assets/img/product/t20/mechanism-6.png'),
          title: '双重镇痛机制<br/>阻断、干扰疼痛传导',
        },
      ],
      advantagesList: [
        {
          path: require('@/assets/img/product/t20/advantages-1.png'),
          title: '智能评估全面分析',
          desc: '国际标准Glazer评估+FSFI量表\n盆底系统+私密系统',
          word: '广告审查批准文号：苏械广审(文)第270509-08977号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司'
        },
        {
          path: require('@/assets/img/product/t20/advantages-2.png'),
          title: '千人千面 专属定制',
          desc: 'AI个性化定制算法 动态调整方案参数\n打造专属健康方案',
          word: '广告审查批准文号：苏械广审(文)第270509-08207号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司'
        },
        {
          path: require('@/assets/img/product/t20/advantages-3.png'),
          title: '主动训练 被动刺激 激活本体感觉',
          desc: '五大训练模式 无缝衔接连续治疗',
          word: '广告审查批准文号：苏械广审(文)第270509-08986号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司'
        },
        {
          path: require('@/assets/img/product/t20/advantages-4.png'),
          title: '两大智能监测系统',
          word: '广告审查批准文号：苏械广审(文)第270509-08586号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20242090347<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用 禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司'
        },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.showCopyrightTimer = setTimeout(() => {
      this.showCopyright = false;
      clearTimeout(this.showCopyrightTimer);
    }, 5000);
    setInterval(() => {
      this.pageScroll();
    }, 1000);
    this.bannerSwiper = new Swiper("#bannerSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
    this.standardSwiper = new Swiper("#standardSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
    this.designSwiper = new Swiper("#designSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
  },
  methods: {
    pageScroll() {
      // 判断 video是不是被 header sh
      const videoDom = document.querySelector(".video-container");
      const headerDom = document.querySelector("#top");
      if (videoDom && headerDom && this.$refs.myVideo) {
        // videoDom 在 屏幕中间
        if (videoDom.getBoundingClientRect().top + videoDom.getBoundingClientRect().height / 2 > headerDom.getBoundingClientRect().height &&
          window.innerHeight - videoDom.getBoundingClientRect().top > videoDom.getBoundingClientRect().height / 2) {
        } else {
          this.$refs.myVideo.pause();
          this.isVideoPlaying = false;
        }
      }
      const videoDomPattern = document.querySelector(".video-container-pattern");
      if (videoDomPattern && headerDom && this.$refs.myVideoPattern) {
        // videoDom 在 屏幕中间
        if (videoDomPattern.getBoundingClientRect().top + videoDomPattern.getBoundingClientRect().height / 2 > headerDom.getBoundingClientRect().height &&
          window.innerHeight - videoDomPattern.getBoundingClientRect().top > videoDomPattern.getBoundingClientRect().height / 2) {
        } else {
          this.$refs.myVideoPattern.pause();
          this.isVideoPlayingPattern = false;
        }
      }
    },
    playState(isPlay) {
      this.isVideoPlaying = isPlay;
      this.showCopyright = true;
      if (isPlay) {
        this.$refs.myVideo.setAttribute("controls", "true");
        this.showCopyrightTimer = setTimeout(() => {
          this.showCopyright = false;
          clearTimeout(this.showCopyrightTimer);
        }, 5000);
      } else {
        this.$refs.myVideo.removeAttribute("controls");
      }
    },
    playVideo() {
      this.$refs.myVideo.muted = false;
      this.$refs.myVideo.play();
    },
    playStatePattern(isPlay) {
      this.isVideoPlayingPattern = isPlay;
      if (isPlay) {
        this.$refs.myVideoPattern.setAttribute("controls", "true");
      } else {
        this.$refs.myVideoPattern.removeAttribute("controls");
      }
    },
    playVideoPattern() {
      this.$refs.myVideoPattern.muted = false;
      this.$refs.myVideoPattern.play();
    }
  }
};
</script>

<style lang="scss" scoped>
#main {
  background-color: #fff;
}

.video-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  > .video {
    width: 100%;
    object-fit: cover;
  }

  > .playBtn {
    position: absolute;
    width: 4.4rem;
  }

  >.copyright {
      position: absolute;
      bottom: 1.2rem;
      left: 0;
      width: 100%;
      padding: 0 2%;
      font-weight: 400;
      font-size: 0.8rem;
      color: rgba(255, 255, 255, 0.6);
      line-height: 1.2rem;
      pointer-events: none;
  }
}

.product-show {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  > .title {
    position: absolute;
    top: 3.85rem;
    text-align: center;
    > img {
      width: 10.77rem;
    }
    > p:nth-child(2) {
      line-height: 2.69rem;
      font-weight: 500;
      font-size: 1.92rem;
      color: rgba(0,0,0,0.85);
      text-align: center;
    }
    >p:nth-child(3) {
      line-height: 1.92rem;
      font-weight: 400;
      font-size: 1.35rem;
      color: rgba(0,0,0,0.85);
      text-align: center;
    }
  }

  > img {
    width: 100%;
    height: 100%;
  }
  > .bottom-gradient {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 5.43rem;
  }
}

.banner {
  width: 100%;
  background: #fff;
  position: relative;
  height: 76rem;
  margin: 2.88rem 0;

  > #bannerSwiper {
    width: 100%;
    height: 72.9rem;
    position: relative;
    margin: 0 auto;
    overflow: hidden;

    .swiper-slide {
      position: relative;

      > .img-container {
        width: 100%;
        height: 100%;
        padding: 0 1.54rem;
        overflow: hidden;
        position: absolute;

        > img {
          border-radius: 1.6rem;
          width: 100%;
        }
      }
    }

    .swiper-pagination {
      bottom: 4rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #fff;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #fff;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
  }

  > .img-copyright {
    bottom: 0;
    color: #d4d4d4;
  }
}

.pattern {
  width: 100%;
  background: #fff;
  position: relative;
  overflow: hidden;

  .video-container-pattern {
    padding: 1.2rem 1.6rem;
    margin-bottom: 2.65rem;
    width: 100%;
    height: 42.4rem;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    > .video {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 1.6rem;
    }

    > .playBtn {
      position: absolute;
      width: 4.4rem;
    }
  }
}

.feature {
  width: 100%;
  background: #fff;
  position: relative;
  overflow: hidden;

  > .video {
    width: 100%;
    object-fit: cover;
  }

  > .video-cover {
    width: 100%;
    height: 5.1rem;
    background: linear-gradient(180deg, rgba(250, 251, 254, 0) 0%, #FFFFFF 90%, #FFFFFF 99%);
    transform: translateY(-100%);
    position: absolute;
  }

  > .title {
    margin-top: 2.31rem;
    text-align: center;
    width: 100%;
    font-weight: 500;
    font-size: 1.92rem;
    color: rgba(0,0,0,0.85);
    line-height: 2.69rem;
  }

  > .desc {
    margin-top: 0.48rem;
    text-align: center;
    width: 100%;
    font-weight: 400;
    font-size: 1.35rem;
    color: rgba(0,0,0,0.85);
    line-height: 2rem;
  }

  > #designSwiper {
    width: 100%;
    height: 35.2rem;
    position: relative;
    margin: 1.83rem 0 5rem 0;
    overflow: hidden;

    > .swiper-wrapper {
      height: 31.29rem;
      > .swiper-slide {
        position: relative;
        padding: 0 1.54rem;

        > .img-container {
          width: 34.4rem;
          height: 100%;
          overflow: hidden;
          position: absolute;
          background: linear-gradient( 180deg, rgba(245,245,247,0.65) 0%, #F5F5F7 100%);
          border-radius: 1.6rem;

          > img {
            width: 100%;
            height: 100%;
          }
        }

        > .Introduction {
          position: absolute;
          bottom: 0;
          width: 34.4rem;
          height: 6.25rem;
          background: linear-gradient( 180deg, rgba(245,245,247,1) 0%, #F5F5F7 100%);
          border-radius: 0 0 1.6rem 1.6rem;
          > .title {
            position: absolute;
            bottom: 2.69rem;
            width: 34.4rem;
            font-weight: 500;
            font-size: 1.4rem;
            color: #000000;
            line-height: 2.4rem;
            text-align: center;
          }

          > .desc {
            position: absolute;
            bottom: 1.15rem;
            width: 34.4rem;
            font-size: 1.2rem;
            color: #666;
            line-height: 1.7rem;
            text-align: center;
          }
        }
      }
    }


    > .swiper-pagination {
      position: relative;
      padding-top: 2.53rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #999999;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #999999;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
  }
}

.research {
  width: 100%;
  height: 54.5rem;
  background: #EBECF2;
  position: relative;

  > .bg {
    width: 100%;
    position: absolute;
    bottom: 0;
    z-index: 1;
  }

  > .title {
    position: absolute;
    top: 4rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
    text-align: center;
    z-index: 2;
  }

  > .sub-title {
    position: absolute;
    top: 7.6rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000;
    line-height: 2rem;
    text-align: center;
    padding: 0 3.4rem;
    z-index: 2;
  }

  > .img {
    position: absolute;
    width: 13.7rem;
    top: 14.6rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
  }
}

.zhuanli {
  position: relative;
  width: 100%;
  height: 58.3rem;
  background: #FAFBFE;

  > .title {
    position: absolute;
    top: 4rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
    text-align: center;
  }

  > .sub-title {
    position: absolute;
    top: 6.9rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000;
    line-height: 2rem;
    text-align: center;
  }

  >.list {
    position: absolute;
    top: 12.9rem;
    padding: 0 0.7rem 4rem 1.6rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 2.4rem;

    >.item {
      width: 11.62rem;
      >.img {
        width: 11.62rem;
        height: 14.72rem;
      }

      >.title {
        font-weight: 500;
        font-size: 1.3rem;
        color: #000000;
        line-height: 1.8rem;
        text-align: center;
        white-space: nowrap;
        padding-right: 0.9rem;
        margin-top: 0.9rem;
      }

      >.desc {
        font-size: 1.1rem;
        color: #999;
        line-height: 1.5rem;
        text-align: center;
        white-space: nowrap;
        padding-right: 0.9rem;
        margin-top: 0.6rem;
      }
    }
  }
}

.technology {
  width: 100%;
  height: 94rem;
  position: relative;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.54rem;
  margin-bottom: 3rem;

  > .top {
    position: relative;
    height: 43.27rem;
    width: 100%;
    overflow: hidden;
    margin-bottom: 1.92rem;
    display: flex;
    flex-direction: column;
    align-items: center;

    > img {
      border-radius: 1.6rem;
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    > p:nth-child(2) {
      position: relative;
      top: 4.81rem;
      font-weight: 500;
      font-size: 1.92rem;
      color: #FFFFFF;
      line-height: 2.69rem;
    }
    > p:nth-child(3) {
      width: 29.13rem;
      position: relative;
      top: 5.77rem;
      font-weight: 400;
      font-size: 1.35rem;
      color: #FFFFFF;
      line-height: 1.93rem;
    }
  }

  > .bottom {
    position: relative;
    width: 100%;
    height: 43.27rem;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;

    > img {
      border-radius: 1.6rem;
      position: absolute;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    > p:nth-child(2) {
      position: relative;
      top: 4.81rem;
      font-weight: 500;
      font-size: 1.92rem;
      color: #FFFFFF;
      line-height: 2.69rem;
    }
    > p:nth-child(3) {
      width: 29.13rem;
      position: relative;
      top: 5.77rem;
      font-weight: 400;
      font-size: 1.35rem;
      color: #FFFFFF;
      line-height: 1.93rem;
    }
  }

  > .img-copyright {
    bottom: 0;
    color: #d4d4d4;
  }
}

.product-standard {
  height: 58.6rem;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #fff;
  display: flex;
  flex-direction: column;

  > .desc {
    position: relative;
    > p {
      display: flex;
      justify-content: center;
      line-height: 2.98rem;
      font-size: 2.12rem;
      color: #000;
      font-weight: 500;
    }
  }

  > #standardSwiper {
    margin-top: 1.92rem;
    height: 100%;
    position: relative;
    overflow: hidden;

    .swiper-slide {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      > .img-container {
        padding: 0 1.54rem;
        width: 100%;
        > img {
          width: 100%;
        }
      }
      > .words {
        font-weight: 500;
        position: absolute;
        font-size: 0.8rem;
        color: rgba(255, 255, 255, 0.6);
        text-align: center;
        line-height: 0.9rem;
        bottom: 13rem;
        width: 80%;
      }
      > .title {
        font-weight: 500;
        margin: 0 1.54rem;
        position: absolute;
        width: 34.5rem;
        height: 9rem;
        display: flex;
        justify-content: center;
        text-align: center;
        line-height: 2.4rem;
        font-size: 1.73rem;
        color: rgba(0,0,0,0.85);
        align-items: center;
        background: linear-gradient( 0deg, rgba(245,245,247,0.65) 0%, #F5F5F7 100%);
        border-radius: 1.09rem 1.09rem 0rem 0rem;
      }
    }

    .swiper-pagination {
      position: absolute;
      bottom: 6rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #999999;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #999999;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
  }

  > .img-copyright {
    bottom: 0.8rem;
    color: #d4d4d4;
  }
}

.four-advantages {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding-top: 0.78rem;
  padding-bottom: 1.32rem;
  gap: 0.4rem;
  background: #fff;

  /* 特性卡片：占比调整为2列布局 */
  > .feature-card {
    padding: 0 1.54rem;
    width: 100%;
    height: 100%;
    border-radius: 1.6rem;
    position: relative;
    overflow: hidden; /* 隐藏文字超出部分，保证动画效果 */
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1.92rem;
    /* 图片容器 */
    > .card-img {
      height: 100%;
      position: relative;
      > img {
        width: 100%;
        height: 100%;
        object-fit: cover; /* 保持图片比例，覆盖容器 */
      }
    }

    /* 文字容器：默认在底部，悬浮时上滑 */
    .text-wrap {
      position: absolute;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 2.8rem;
      /* 主文字样式（默认显示） */
      > .main-text {
        font-weight: 500;
        line-height: 2.4rem;
        color: rgba(0,0,0,0.85);
        font-size: 1.73rem;
        margin-bottom: 0.38rem;
        white-space: pre-line; /* 解析换行符\n，实现多行文字 */
        text-align: center;
      }

      /* 子文字样式（悬浮时显示） */
      > .sub-text {
        font-weight: 400;
        line-height: 1.92rem;
        color: rgba(0,0,0,0.65);
        font-size: 1.35rem;
        text-align: center;
        white-space: pre-line; /* 解析换行符\n，实现多行文字 */
      }
    }
    >.img-copyright {
      position: relative;
      right: -0.34rem;
      height: 6rem;
      top: 1rem;
      color: #d4d4d4;
    }
  }
}
</style>
